
export const types = {
    SET_RECORDER: 'ui/timeRecorder/SET_RECORDER' as const,
  };
  
  export const setRecorder = (payload: any) => ({
    type: types.SET_RECORDER,
    payload,
  });
  
  type Actions = (
    | ReturnType<typeof setRecorder>
  );
  
  export default Actions;
  